import * as React from "react";
import { List } from "@fluentui/react/lib/List";
import { getTheme, ITheme, mergeStyleSets } from "@fluentui/react/lib/Styling";

export const FaqList: React.FunctionComponent = () => {
  const theme: ITheme = getTheme();
  const { palette, fonts } = theme;
  const classNames = mergeStyleSets({
    listGridExampleTile: {
      textAlign: "left",
      outline: "none",
      position: "relative",
      marginBottom: 10,
      marginTop: 10,
      selectors: {
        "focus:after": {
          border: `1px solid ${palette.white}`,
        },
      },
    },
    listGridTitle: {
      fontWeight: "bold",
      padding: 5,
      paddingLeft: 10,
      fontFamily: "ShentoxMedium",
      fontSize: fonts.large.fontSize,
    },
    listGridText: {
      paddingLeft: 10,
      paddingRight: 15,
      width: "100%",
      fontSize: fonts.medium.fontSize,
      boxSizing: "border-box",
      fontFamily: "ShentoxRegular",
    },
  });
  const items = [
    ...[
      {
        name: "Welcome on board, capsuleer! ",
        text: "You’re taking the first step towards data dominance by turning your information into power. Data extraction from New Eden has become easier than ever before as you can now log in and pull in-game data directly into spreadsheets. You can extract generic New Eden data as well as character-based data, such as wallet balance, recent market orders and asset information. The ability to easily work with these figures in any number of ways will enhance your data driven warfare.",
      },
    ],
  ];
  /*
  
      {
        name: "Functions",
        text: "Here are some example functions you can use with your logged in character",
        list: ["=EVEONLINE.ACTIVE_CHARACTER()", "=EVEONLINE.CHARACTER_SKILLS()", "=EVEONLINE.CHARACTER_ORDERS()"],
      },

      */
  const onRenderCell = React.useCallback((item: any) => {
    return (
      <div className={classNames.listGridExampleTile} data-is-focusable>
        <div className={classNames.listGridTitle}>{item.name}</div>
        <div className={classNames.listGridText} dangerouslySetInnerHTML={{ __html: item.text }} />
        {item.list && (
          <ul>
            {item.list.map((item: any, index: any) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}
      </div>
    );
  }, []);

  return (
    <div data-is-scrollable>
      <List items={items} onRenderCell={onRenderCell} />
    </div>
  );
};
